import { useEffect, useState } from 'react'
import { GetCategoryNavigationTree } from '../../../Services/AssortCategoriesService';
import { useConfig } from '../../../Providers/ConfigProvider';
import axios from 'axios';

const useCategoryNavigationTree = (activeCategory, setActiveCategory) => {
    const [categories, setCategories] = useState(null)
    const [isLoadingTree, setIsLoadingTree] = useState(false)
    const { api } = useConfig()

    useEffect(() => {
        const source = axios.CancelToken.source()
        handleSetCategory(source.token)

        return () => {
            source.cancel()
        }
    }, [activeCategory])

    const handleSetCategory = async (cancelToken) => {
        setIsLoadingTree(true)
        if (activeCategory) {
            const nodeId = activeCategory.nodeId ? activeCategory.nodeId : activeCategory[0].nodeId
            await GetCategoryNavigationTree(api, nodeId, cancelToken)
                .then(res => {
                    setCategories(res.data.reverse());
                    localStorage.setItem("categoryNavigationTree", JSON.stringify(res.data))
                }).catch(e => {
                    if (!axios.isCancel(e)) {
                        console.log(e)
                    }
                })
        } else {
            let CategoryNavigationItems = JSON.parse(localStorage.getItem("categoryNavigationTree"));
            if (CategoryNavigationItems) {
                setCategories(CategoryNavigationItems)
                setActiveCategory(CategoryNavigationItems[CategoryNavigationItems.length - 1])
            } else {
                setCategories(null)
            }
        }
        setIsLoadingTree(false)
    }

    return { categories, isLoadingTree }
}

export default useCategoryNavigationTree